import { useMutation, useQueryClient } from '@tanstack/react-query';
import { runStandardAnalysis, runAgenticAnalysis } from '../api/analysis';

/**
 * Mutation hook for standard (single-shot) analysis.
 * On success, invalidates the case query so the updated ai_summary is refetched.
 */
export const useStandardAnalysis = (caseNumber) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ documentContent } = {}) =>
      runStandardAnalysis(caseNumber, documentContent),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['case', caseNumber] });
    },
  });
};

/**
 * Mutation hook for agentic (multi-agent) analysis.
 * Returns AgenticAnalysisResponse when all agents complete.
 */
export const useAgenticAnalysis = (caseNumber) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => runAgenticAnalysis(caseNumber),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['case', caseNumber] });
    },
  });
};
